import { filter, head, propEq } from 'ramda';

/**
 * Filters the given Array down to only those whose id's match the supplied id
 * and returns the first matching object.
 *
 * e.g.
 *   `firstById([ {id: 'A', x:1}, {id: 'B',  x:2}, {id: 'A',  x:3} ], 'A');`
 * will return
 *   `{id: 'A', x:1}`
 *
 * @param {Array} arr An array of objects, each with an `id` property.
 * @param {string} id The object id to search for
 */
var firstById = function firstById(arr, id) {
  return head(filter(propEq('id', id), arr));
};

/**
 * Maps over the provided `ids` and returns a new array wherein each string has
 * been replaced by the first object holding that id from inside `collection`.
 *
 * e.g.
 *   `mapById([ {id: 'A', x:1}, {id: 'B',  x:2}, {id: 'A',  x:3} ], ['A', 'B']);`
 * will return
 *   `[{id: 'A', x:1}, {id: 'B',  x:2}]`
 *
 * @param {Array} collection an array of objects, each with an id property
 * @param {Array} ids an array of strings, each of which corresponds to an
 */
var mapById = function mapById(collection, ids) {
  return ids.reduce(function (arr, id) {
    var found = collection.find(propEq('id', id));
    if (found) {
      return arr.concat([found]);
    }
    return arr;
  }, []);
};
export { firstById, mapById };